import React from 'react';
import { Link } from 'react-router-dom';

const Summercamp = () => {
  const cardStyle = {
    backgroundColor: '#ffffff',
    padding: '2rem',
    borderRadius: '12px',
    border: '1px solid #e5e7eb',
    boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
    textDecoration: 'none',
    color: 'inherit',
    display: 'block',
    transition: 'all 0.3s ease',
    height: '100%',
    marginBottom: '1.5rem'
  };

  const sectionStyle = {
    marginBottom: '3rem',
    padding: '2rem',
    backgroundColor: '#f8fafc',
    borderRadius: '16px',
    border: '1px solid #e2e8f0'
  };

  return (
    <div className="container" style={{maxWidth: '1200px', margin: '0 auto', padding: '2rem'}}>
      <div style={{textAlign: 'center', marginBottom: '3rem'}}>
        <h1 className="page-title" style={{fontSize: '2.5rem', fontWeight: 'bold', color: '#1e293b', marginBottom: '1rem'}}>
          ☀️ EBTA Summer Camp 2026
        </h1>
        <p className="page-subtitle" style={{fontSize: '1.3rem', color: '#2563eb', fontWeight: '600', maxWidth: '800px', margin: '0 auto'}}>
          Co-creation with Images and Words
        </p>
        <p style={{fontSize: '1.1rem', color: '#64748b', maxWidth: '800px', margin: '1rem auto 0'}}>
          We warmly invite Solution Focused practitioners to meet, learn, and enjoy time together at the EBTA Summer Camp 2026, exploring the theme of co-creation with images and words.
        </p>
      </div>

      {/* Main Event Information */}
      <div style={{
        background: 'linear-gradient(135deg, #f0f9ff 0%, #dbeafe 100%)',
        borderRadius: '16px',
        padding: '2rem',
        marginBottom: '3rem',
        border: '1px solid #3b82f6'
      }}>
        <div style={{display: 'flex', alignItems: 'center', gap: '1rem', marginBottom: '2rem'}}>
          <div style={{fontSize: '2.5rem'}}>🎨</div>
          <div>
            <h2 style={{margin: 0, color: '#1e293b', fontSize: '1.8rem'}}>Summer Camp 2026 Details</h2>
            <p style={{margin: '0.5rem 0 0 0', color: '#1e40af', fontWeight: '600'}}>Wolimierz, Poland</p>
          </div>
        </div>
        
        <div style={{display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '1.5rem', marginBottom: '2rem'}}>
          <div style={{backgroundColor: 'white', padding: '1.5rem', borderRadius: '8px', border: '1px solid #e2e8f0'}}>
            <div style={{display: 'flex', alignItems: 'center', gap: '0.5rem', marginBottom: '1rem'}}>
              <span style={{fontSize: '1.5rem'}}>📅</span>
              <strong style={{color: '#1e40af', fontSize: '1.1rem'}}>When</strong>
            </div>
            <p style={{color: '#475569', margin: 0, lineHeight: '1.6'}}>
              16–21 July 2026<br/>
              <em>During the annual art festival</em>
            </p>
          </div>
          
          <div style={{backgroundColor: 'white', padding: '1.5rem', borderRadius: '8px', border: '1px solid #e2e8f0'}}>
            <div style={{display: 'flex', alignItems: 'center', gap: '0.5rem', marginBottom: '1rem'}}>
              <span style={{fontSize: '1.5rem'}}>📍</span>
              <strong style={{color: '#1e40af', fontSize: '1.1rem'}}>Where</strong>
            </div>
            <p style={{color: '#475569', margin: 0, lineHeight: '1.6'}}>
              Wolimierz, Poland<br/>
              <em>A village known for its artistic and free spirit</em><br/>
              <small>Nearest airport: Wrocław (train, bus, or car onward)</small>
            </p>
          </div>
        </div>

        <div style={{
          background: '#fef3c7',
          padding: '1rem 1.5rem',
          borderRadius: '8px',
          border: '1px solid #fde047',
          textAlign: 'center'
        }}>
          <strong style={{color: '#92400e'}}>🎯 Limited to 15 participants – first come, first served!</strong>
        </div>
      </div>

      {/* Photos Section */}
      <div style={{marginBottom: '3rem'}}>
        <div style={{display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '1.5rem'}}>
          <div style={{borderRadius: '12px', overflow: 'hidden', boxShadow: '0 4px 20px rgba(0, 0, 0, 0.1)'}}>
            <img 
              src="/images/summercamp/summercamp1.jpg" 
              alt="EBTA Summer Camp - Creative workshop session" 
              style={{width: '100%', height: '250px', objectFit: 'cover'}}
            />
          </div>
          <div style={{borderRadius: '12px', overflow: 'hidden', boxShadow: '0 4px 20px rgba(0, 0, 0, 0.1)'}}>
            <img 
              src="/images/summercamp/summercamp2.jpg" 
              alt="EBTA Summer Camp - Wolimierz village setting" 
              style={{width: '100%', height: '250px', objectFit: 'cover'}}
            />
          </div>
          <div style={{borderRadius: '12px', overflow: 'hidden', boxShadow: '0 4px 20px rgba(0, 0, 0, 0.1)'}}>
            <img 
              src="/images/summercamp/summercamp3.jpg" 
              alt="EBTA Summer Camp - Group learning session" 
              style={{width: '100%', height: '250px', objectFit: 'cover'}}
            />
          </div>
        </div>
      </div>

      {/* Trainers and Facilitators */}
      <div style={sectionStyle}>
        <div style={{display: 'flex', alignItems: 'center', marginBottom: '2rem'}}>
          <div style={{fontSize: '2rem', marginRight: '1rem'}}>👥</div>
          <h2 style={{fontSize: '1.8rem', fontWeight: 'bold', color: '#1e293b', margin: 0}}>Meet Your Trainers</h2>
        </div>
        
        <div style={{display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '1.5rem', marginBottom: '2rem'}}>
          <div style={{backgroundColor: 'white', padding: '1.5rem', borderRadius: '8px', border: '1px solid #e2e8f0', display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center'}}>
            <img
              src="/images/team/katrin-berger.jpg"
              alt="Katrin Berger"
              style={{width: '120px', height: '160px', objectFit: 'cover', borderRadius: '8px', marginBottom: '1rem'}}
            />
            <h3 style={{color: '#2563eb', fontSize: '1.2rem', fontWeight: '600', marginBottom: '0.5rem'}}>
              Katrin Berger (Germany)
            </h3>
            <p style={{color: '#6b7280', lineHeight: '1.6', fontSize: '0.95rem'}}>
              Family therapist, mediator, and trainer, founder of Lösungswerkstatt.
            </p>
          </div>

          <div style={{backgroundColor: 'white', padding: '1.5rem', borderRadius: '8px', border: '1px solid #e2e8f0', display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center'}}>
            <img
              src="/images/team/ella-de-jonge.jpg"
              alt="Ella de Jong"
              style={{width: '120px', height: '160px', objectFit: 'cover', borderRadius: '8px', marginBottom: '1rem'}}
            />
            <h3 style={{color: '#2563eb', fontSize: '1.2rem', fontWeight: '600', marginBottom: '0.5rem'}}>
              Ella de Jong (Netherlands)
            </h3>
            <p style={{color: '#6b7280', lineHeight: '1.6', fontSize: '0.95rem'}}>
              Teacher and author of Solution Focused Mentoring, known for her creative, hands-on workshops.
            </p>
          </div>

          <div style={{backgroundColor: 'white', padding: '1.5rem', borderRadius: '8px', border: '1px solid #e2e8f0', display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center'}}>
            <img
              src="/images/team/matthias-schwab.jpg"
              alt="Matthias Schwab"
              style={{width: '120px', height: '160px', objectFit: 'cover', borderRadius: '8px', marginBottom: '1rem'}}
            />
            <h3 style={{color: '#2563eb', fontSize: '1.2rem', fontWeight: '600', marginBottom: '0.5rem'}}>
              Matthias Schwab (Germany)
            </h3>
            <p style={{color: '#6b7280', lineHeight: '1.6', fontSize: '0.95rem'}}>
              Visual artist, psychologist, EBTA Board member, and coordinator of the Theory Task Group.
            </p>
          </div>

          <div style={{backgroundColor: 'white', padding: '1.5rem', borderRadius: '8px', border: '1px solid #e2e8f0', display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center'}}>
            <img
              src="/images/team/sebastien-vernieuwe.jpg"
              alt="Sébastien Vernieuwe"
              style={{width: '120px', height: '160px', objectFit: 'cover', borderRadius: '8px', marginBottom: '1rem'}}
            />
            <h3 style={{color: '#2563eb', fontSize: '1.2rem', fontWeight: '600', marginBottom: '0.5rem'}}>
              Sébastien Vernieuwe (Belgium)
            </h3>
            <p style={{color: '#6b7280', lineHeight: '1.6', fontSize: '0.95rem'}}>
              Trainer at the Korzybski Institute, psychotherapist, and artist exploring the meeting point of creativity and SF practice.
            </p>
          </div>
        </div>

        <div style={{backgroundColor: '#f0fdf4', padding: '1.5rem', borderRadius: '8px', border: '1px solid #bbf7d0', marginBottom: '1.5rem'}}>
          <h3 style={{color: '#166534', fontSize: '1.2rem', fontWeight: '600', marginBottom: '1rem', display: 'flex', alignItems: 'center'}}>
            <span style={{marginRight: '0.5rem'}}>🇵🇱</span>
            Organizing Team (Poland)
          </h3>
          <p style={{color: '#6b7280', lineHeight: '1.6', margin: 0}}>
            <strong>Andreea Żak, Magdalena Szutarska, and Katarzyna Panejko-Wanat</strong> – experienced SF practitioners passionate about combining language, emotion, and imagery in therapy and training.
          </p>
        </div>

        <div style={{backgroundColor: '#fef3c7', padding: '1.5rem', borderRadius: '8px', border: '1px solid #fde047'}}>
          <h3 style={{color: '#a16207', fontSize: '1.2rem', fontWeight: '600', marginBottom: '1rem', display: 'flex', alignItems: 'center'}}>
            <span style={{marginRight: '0.5rem'}}>📸</span>
            Bonus Workshop
          </h3>
          <p style={{color: '#6b7280', lineHeight: '1.6', margin: 0}}>
            <strong>Photography workshop with Taida Tarabuła</strong>, photographer and educator, exploring photography as a visual language in therapy and self-development.
          </p>
        </div>
      </div>

      {/* Participation Requirements and Costs */}
      <div style={sectionStyle}>
        <div style={{display: 'flex', alignItems: 'center', marginBottom: '2rem'}}>
          <div style={{fontSize: '2rem', marginRight: '1rem'}}>💰</div>
          <h2 style={{fontSize: '1.8rem', fontWeight: 'bold', color: '#1e293b', margin: 0}}>Participation & Costs</h2>
        </div>
        
        <div style={{display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '1.5rem'}}>
          <div style={{backgroundColor: 'white', padding: '1.5rem', borderRadius: '8px', border: '1px solid #e2e8f0'}}>
            <h3 style={{color: '#059669', fontSize: '1.2rem', fontWeight: '600', marginBottom: '1rem', display: 'flex', alignItems: 'center'}}>
              <span style={{marginRight: '0.5rem'}}>✅</span>
              Requirements
            </h3>
            <p style={{color: '#6b7280', lineHeight: '1.6'}}>
              <strong>Curiosity and openness to learning</strong> within the Solution-Focused approach are the only requirements.
            </p>
          </div>

          <div style={{backgroundColor: 'white', padding: '1.5rem', borderRadius: '8px', border: '1px solid #e2e8f0'}}>
            <h3 style={{color: '#2563eb', fontSize: '1.2rem', fontWeight: '600', marginBottom: '1rem', display: 'flex', alignItems: 'center'}}>
              <span style={{marginRight: '0.5rem'}}>💶</span>
              Fee Structure
            </h3>
            <p style={{color: '#6b7280', lineHeight: '1.6'}}>
              <strong>€165 for accommodation</strong> (paid after confirmation)<br/>
              <strong>+ shared cost for food</strong>
            </p>
          </div>

          <div style={{backgroundColor: 'white', padding: '1.5rem', borderRadius: '8px', border: '1px solid #e2e8f0'}}>
            <h3 style={{color: '#dc2626', fontSize: '1.2rem', fontWeight: '600', marginBottom: '1rem', display: 'flex', alignItems: 'center'}}>
              <span style={{marginRight: '0.5rem'}}>⏰</span>
              Application Deadline
            </h3>
            <p style={{color: '#6b7280', lineHeight: '1.6'}}>
              <strong>Apply by: 15 February 2026</strong><br/>
              <em>Limited to 15 participants – first come, first served</em>
            </p>
          </div>
        </div>
      </div>

      {/* Apply Now Section */}
      <div style={{
        background: 'linear-gradient(135deg, #059669, #047857)',
        borderRadius: '16px',
        padding: '3rem 2rem',
        textAlign: 'center',
        color: 'white',
        marginBottom: '3rem'
      }}>
        <div style={{fontSize: '3rem', marginBottom: '1rem'}}>🎨</div>
        <h2 style={{fontSize: '2rem', fontWeight: 'bold', marginBottom: '1rem', color: 'white'}}>
          Ready to Join Us?
        </h2>
        <p style={{fontSize: '1.2rem', marginBottom: '2rem', maxWidth: '600px', margin: '0 auto 2rem', opacity: 0.9}}>
          Join us for a week of creativity, reflection, and connection in a truly inspiring setting!
        </p>
        
        <a 
          href="https://forms.gle/98oiUDG3YA7sWMiH6"
          target="_blank"
          rel="noopener noreferrer"
          style={{
            display: 'inline-flex',
            alignItems: 'center',
            backgroundColor: 'white',
            color: '#059669',
            padding: '1rem 2rem',
            borderRadius: '10px',
            textDecoration: 'none',
            fontWeight: '700',
            fontSize: '1.1rem',
            boxShadow: '0 4px 20px rgba(0, 0, 0, 0.2)',
            transition: 'all 0.3s ease',
            marginBottom: '1rem'
          }}
          onMouseEnter={(e) => {
            e.target.style.transform = 'translateY(-3px)';
            e.target.style.boxShadow = '0 8px 25px rgba(0, 0, 0, 0.3)';
          }}
          onMouseLeave={(e) => {
            e.target.style.transform = 'translateY(0)';
            e.target.style.boxShadow = '0 4px 20px rgba(0, 0, 0, 0.2)';
          }}
        >
          <span style={{marginRight: '0.5rem', fontSize: '1.2rem'}}>📝</span>
          Apply Now
        </a>
        
        <p style={{fontSize: '0.9rem', opacity: 0.8, marginTop: '1rem'}}>
          Application deadline: <strong>15 February 2026</strong>
        </p>
      </div>

      {/* Additional Information */}
      <div style={{...sectionStyle, backgroundColor: '#f1f5f9', textAlign: 'center'}}>
        <div style={{display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: '1.5rem'}}>
          <div style={{fontSize: '2rem', marginRight: '1rem'}}>ℹ️</div>
          <h2 style={{fontSize: '1.8rem', fontWeight: 'bold', color: '#1e293b', margin: 0}}>Need More Information?</h2>
        </div>
        <p style={{fontSize: '1.1rem', color: '#64748b', marginBottom: '2rem', maxWidth: '600px', margin: '0 auto 2rem'}}>
          Full travel details will be sent to participants after confirmation. For questions about the Summer Camp, feel free to contact us.
        </p>
        <div style={{display: 'flex', gap: '1rem', flexWrap: 'wrap', justifyContent: 'center'}}>
          <Link 
            to="/contact"
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              backgroundColor: '#2563eb',
              color: 'white',
              padding: '1rem 2rem',
              borderRadius: '10px',
              textDecoration: 'none',
              fontWeight: '600',
              fontSize: '1rem',
              boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)',
              transition: 'all 0.3s ease'
            }}
            onMouseEnter={(e) => {
              e.target.style.backgroundColor = '#1d4ed8';
              e.target.style.transform = 'translateY(-2px)';
              e.target.style.boxShadow = '0 10px 15px -3px rgba(0, 0, 0, 0.1)';
            }}
            onMouseLeave={(e) => {
              e.target.style.backgroundColor = '#2563eb';
              e.target.style.transform = 'translateY(0)';
              e.target.style.boxShadow = '0 4px 6px -1px rgba(0, 0, 0, 0.1)';
            }}
          >
            <span style={{marginRight: '0.5rem'}}>📧</span>
            Contact Us
          </Link>
          <Link 
            to="/membership"
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              backgroundColor: '#059669',
              color: 'white',
              padding: '1rem 2rem',
              borderRadius: '10px',
              textDecoration: 'none',
              fontWeight: '600',
              fontSize: '1rem',
              boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)',
              transition: 'all 0.3s ease'
            }}
            onMouseEnter={(e) => {
              e.target.style.backgroundColor = '#047857';
              e.target.style.transform = 'translateY(-2px)';
              e.target.style.boxShadow = '0 10px 15px -3px rgba(0, 0, 0, 0.1)';
            }}
            onMouseLeave={(e) => {
              e.target.style.backgroundColor = '#059669';
              e.target.style.transform = 'translateY(0)';
              e.target.style.boxShadow = '0 4px 6px -1px rgba(0, 0, 0, 0.1)';
            }}
          >
            <span style={{marginRight: '0.5rem'}}>👥</span>
            Become a Member
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Summercamp;
